// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const PopoverContract = contract({
  name: "Popover",
  description: "A floating panel anchored to a trigger that contains interactive content — date pickers, color pickers, filter pickers, \"more info\" panels, inline forms. Differs from Tooltip (hover-only, no focusable content) and Dialog (modal, blocks the page). DatePicker, DateRangePicker, and the Combobox pattern all compose Popover internally.",
  import: "@gradeui/ui",
  aliases: ["popover","dropdown panel","floating panel","inline editor","attached panel","filter pop","popover view","popoverpresentation","attached popover","glass popover","frosted popover","inspector popover"],
  subcomponents: ["PopoverTrigger","PopoverContent","PopoverAnchor"],
  composesWith: ["Button (as trigger)","Calendar (date picker)","Command (combobox)","Form controls (inline edit popover)","Code (code-detail popovers)"],
  styleDefaults: {"PopoverContent":"z-50 w-72 rounded-md border p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-(--radix-popover-content-transform-origin)"},
  props: {
  "open": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "defaultOpen": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "onOpenChange": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "modal": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "asChild": {
      schema: z.boolean().optional(),
      design: "plumbing",
      description: "usually a Button",
  },
  "side": {
      schema: z.enum(["top", "right", "bottom", "left"]).optional(),
      design: "knob",
  },
  "align": {
      schema: z.enum(["start", "center", "end"]).optional(),
      design: "knob",
  },
  "sideOffset": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "alignOffset": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "collisionPadding": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "className": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "surface": {
      schema: z.enum(["solid", "translucent", "glass", "glass-strong"]).optional(),
      design: "knob",
      description: "what the popover surface is *made of*. `solid` is the default opaque `bg-popover`. `translucent` is the Apple HIG menu-sheet feel. `glass` for floating panels over rich canvases (Studio inspector, image-tool palette).",
  },
  },
});
